import { of, restore, remove, $place, $input, } from '../ui/messages';
import { ask, } from '../utils/popups';



export { handle };



function handle(instance, message, fallback = text => ask( text, 'errors::common notification', 'actions::close' )) {
    const { text } = message;
    if (!text)
        return fallback( 'errors::no error info, see logs' );

    if (!$place( instance, message ).length)
        return fallback( text ); 

    // remove if present
    remove( instance, text );
    // add as new
    of( instance ).push( message );
    
    restore( instance );
    clearTimeout( instance.restoreTimeout );
    instance.restoreTimeout = setTimeout( () => restore( instance ), 5100 );

    const $inputField = $input( instance, message );
    if ($inputField.length)
        $inputField.addClass( '__blink' ),
        setTimeout( () => $inputField.removeClass( '__blink' ), 500 ),
        setTimeout( () => $inputField
            // add - to correctly handle field/html (div with button next)
            .add( $inputField.closest( '.form-control' ).find( 'button' ) )
            .focus(), 0 );
    
    return instance;
}




// WEBPACK FOOTER //
// ./src/js/service/messages.js